module.exports = __webpack_public_path__ + "static/img/account_safe.9ddd11d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cplan/account_safe.png
// module id = O8q7
// module chunks = 39